import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class GetPromptPropertiesService extends BaseService {
  constructor() {
    super(constants.GET_PROPERTIES_ADMIN_DATA, 'GetPromptPropertiesServiceStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('aiadmin').post(`/chatutility/prompt/getpromptproperties`, event.payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('promptProperties').setPropertiesResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
